<template>
  <section
    v-loading="loading"
    class="selected-test-preview"
    id="wound-panel-tests-preview"
  >
    <el-tabs>
      <el-tab-pane
        v-for="(category, index) of getCaseCategoryData(test.case_type_code)"
        :key="index"
      >
        <template #label>
          <div class="custom-tabs-label">
            <span @click="showWoundTests">
              {{ index + 1 }}. {{ category.panel_title }}
            </span>
            <span
              class="custom-tab-close-btn"
              @click="remove(category)"
              v-if="notCreateCase && isBillingUser"
            >
              <img
                src="@/assets/images/fax-tag-close.svg"
                alt="icon"
                width="30"
              />
            </span>
          </div>
        </template>
        <div class="default-modal" v-if="woundTestsPopup">
          <el-dialog v-model="woundTestsPopup">
            <div class="dialog-header">
              <span class="header-part">Wound</span>
              <el-button
                size="medium"
                class="el-white"
                type="info"
                plain
                @click="woundTestsPopup = false"
              >
                <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
              /></el-button>
            </div>
            <div class="popup-panels-blocks">
              <ul class="check-list-gastro">
                <li
                  v-for="(item, index) of getCategoryWiseTestsData(
                    category.case_type_code,
                    category.panel_code
                  )"
                  :key="index"
                >
                  <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                    <el-checkbox :label="item._id" :value="item" disabled>
                      {{ item.test_name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </div>
          </el-dialog>
        </div>
      </el-tab-pane>
    </el-tabs>
  </section>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";

import { mapGetters } from "vuex";

export default {
  mixins: [UserPermissionsHelper, AppHelper],
  components: {},
  props: ["panelTestsData", "test", "allSelectedTests"],

  data() {
    return {
      activeNameCollapse: "",
      WoundPanels: [],
      selectedWoundPanels: [],
      testsData: [],
      existed: [],
      loading: false,
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup:[]
      },
      allTests: "",
      caseRouteNames: [
        "NewCase",
        "Case-Information-Update",
        "NewOrder",
        "Edit-Order-Info",
        "SendOutsView",
        "PendingCasesEdit",
        "Concurrent-Case-Information-Update",
      ],
      woundTestsPopup: false,
    };
  },
  async mounted() {
    this.allTests = this.allSelectedTests;
    this.panelsTestsData = this.panelTestsData;
    this.loading = true;
    try {
      await this.$store.dispatch("cases/fetchCoriellTestsOfPanel", {
        lab_id: this.getUserPrimaryLabId,
        case_type: "WOUND",
      });
      this.WoundPanels =
        this.getCorriellTestPanels && this.getCorriellTestPanels.data
          ? this.getCorriellTestPanels.data
          : [];

      this.setSelectedCoriellPanels();

      // eslint-disable-next-line no-empty
    } catch (err) {
      console.log(err);
    }

    this.testsData = JSON.parse(
      JSON.stringify(this.panelsTestsData.selectedTestIds)
    );
    this.selectedCoriellPanels = JSON.parse(
      JSON.stringify(this.panelsTestsData.selectedCoriellPanels)
    );
    this.loading = false;
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser","getUserPrimaryLabId"],),
    ...mapGetters("cases", ["getCaseInformation", "getCorriellTestPanels"]),
    ...mapGetters("profile", ["getProfileData"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
    ]),
    notCreateCase() {
      if (this.caseRouteNames.indexOf(this.$route.name) != -1) {
        return true;
      }
      return false;
    },
    isEdit() {
      if (this.$route.query.edit) {
        return true;
      } else if (
        !this.getCaseInformation ||
        !this.getCaseInformation.tests_info ||
        this.getCaseInformation.tests_info.length === 0
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    showWoundTests() {
      this.woundTestsPopup = true;
    },
    remove(test) {
      let testName = test.panel_code.split("_").join(" ");
      this.$confirm(
        `Are you sure want to remove this
        <br/>
        <b style="color:#0A5DA6">"${testName}"</b> test type ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        for (var i = 0; i < this.allTests.length; i++) {
          var obj = this.allTests[i];

          if (test.panel_code.indexOf(obj.panel_code) !== -1) {
            this.allTests.splice(i, 1);
            i--;
          }
        }
      });
    },
    checkNotExistedInSelection(option) {
      let selectedWoundPanelValue = this.existed.find(
        (e) => e.case_type === "WOUND"
      );

      if (selectedWoundPanelValue) {
        return selectedWoundPanelValue.test_panels.find(
          (panel) => panel == option.code
        )
          ? false
          : true;
      }
      return true;
    },
    setSelectedCoriellPanels() {
      this.selectedWoundPanels = [];
      this.existed = [...this.panelsTestsData.selectedCoriellPanels];
      let selectedWoundPanelValue =
        this.panelsTestsData.selectedCoriellPanels.find(
          (e) => e.case_type === "WOUND"
        );

      if (selectedWoundPanelValue) {
        selectedWoundPanelValue.test_panels.forEach((panel) => {
          let selectedWoundPanel = this.WoundPanels.find(
            (x) => x.group_code == panel
          );
          this.selectedWoundPanels.push(selectedWoundPanel);
        });
      }
    },
    getUniquIds(ids) {
      return Array.from(new Set(ids));
    },
    getCategoryWiseTestsData(caseType, category) {
      const data = this.getNewLabGroupPanelTests.filter(
        (el) => el.case_type_code === caseType && el.panel_code === category
      );
      return data;
    },
    getCaseCategoryData(caseType) {
      let selectedTestPanelIds = this.panelsTestsData.selectedCategories.map(
        (e) => e.panel_id
      );

      let data = this.getNewLabGroupPanelTests.filter((e) =>
        selectedTestPanelIds.includes(e.panel_id)
      );

      return data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    }
  },
};
</script>
<style lang="scss">
.test-panels-blocks {
  .toxicology-text-panels {
    padding: 10px 0;
    position: relative;
  }

  .toxicology-text-panels:not(:last-child):after {
    content: "";
    position: absolute;
    width: 100%;
    left: 0;
    // border-bottom: 1px solid #e8e4e4;
  }
  .check-list-woundpanel {
    display: grid;
    grid-template-columns: repeat(3, 33.3%);
    -moz-column-gap: 10px;
    column-gap: 10px;
    li {
      margin: 7px 0;

      &:not(:last-child) {
        margin-right: 15px;
      }
    }
    .el-checkbox {
      height: auto;
    }

    .el-checkbox-group {
      .el-checkbox {
        height: 20px;
      }

      .el-checkbox__input .el-checkbox__inner {
        border-color: transparent;
        box-shadow: 0 0 0 1px #ced1d6;
        border-radius: 4px;
        width: 17px;
        height: 17px;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background: #273480;
        border-color: #ffffff;
        box-shadow: 0 0 0 1px #ced1d6;
        width: 17px;
        height: 17px;
      }
      .el-checkbox__inner::after {
        box-sizing: content-box;
        content: "";
        border: 2px solid var(--el-checkbox-checked-icon-color);
        border-left: 0;
        border-top: 0;
        height: 9px;
        left: 5px;
        position: absolute;
        top: 1px;
        transform: rotate(45deg) scaleY(1);
        width: 3px;
        transition: transform 0.15s ease-in 50ms;
        transform-origin: center;
      }

      .el-checkbox__label {
        color: #34495e;
      }
    }
  }

  .test-group-title {
    font-size: 16px;
    color: #333;
    margin-bottom: 5px;
  }
}
</style>
